const constants = {
    API_URL: process.env.REACT_APP_ENVIRONMENT === "development" ? process.env.REACT_APP_DEV_URL : process.env.REACT_APP_ENVIRONMENT === "testing" ? process.env.REACT_APP_TESTING_URL : process.env.REACT_APP_LIVE_URL,
    PORTAL_URL: process.env.REACT_APP_ENVIRONMENT === "development" ? 'http://localhost:3000' : process.env.REACT_APP_ENVIRONMENT === "testing" ? process.env.REACT_APP_TESTING_PUBLIC_URL : process.env.REACT_APP_PUBLIC_URL,
    REQUIRE_INTERCEPTORS: {
        requestHandlerEnabled: true,
        responseHandlerEnabled: true
    },
    MAPQUEST_URL: 'http://www.mapquestapi.com/',
    MAPQUEST_KEY: 'PNCgtAvNVdDt03jC73fmtmawEyLdkb3Z',
    WEATHER_API: 'https://wttr.in/',
    US_STATES: {
        "AL": "Alabama",
        "AK": "Alaska",
        "AS": "American Samoa",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District Of Columbia",
        "FM": "Federated States Of Micronesia",
        "FL": "Florida",
        "GA": "Georgia",
        "GU": "Guam",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MH": "Marshall Islands",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "MP": "Northern Mariana Islands",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PW": "Palau",
        "PA": "Pennsylvania",
        "PR": "Puerto Rico",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VI": "Virgin Islands",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
    }
};

export default constants;